
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import useTranslation from "next-translate/useTranslation";
import { useIsMobile, withDeviceType } from "../lib/media";
import { Text, Box } from "rebass/styled-components";
import Layout from "../components/Layout";
import HeroLanding from "../components/landings/HeroLanding";
import Headline from "../components/common/Headline";
import TextWithImg from "../components/TextWithImg";
import { useContext } from "react";
import { LocaleContext } from "../components/locale";
import { Accordion } from "../components/common";

const Benefits = () => {
  const { t } = useTranslation("ourservices");
  const benefitIcons = ["vet", "cancellation", "vetted", "secure", "support"];
  const listBenefits = [...Array(5)].map((_, i) => {
    return {
      icon: benefitIcons[i],
      title: t(`benefitTitle${i + 1}`),
      description: t(`benefitDesc${i + 1}`)
    };
  });
  const additionalInfo = {
    iconColor: "samoyedWhite",
    textColor: "samoyedWhite",
    expandIcon: "plus",
    retractIcon: "minus",
    expandIconColor: "samoyedWhite"
  };

  return (
    <Box variant="benefits.ourservices.box">
      <Text as="h2" variant="benefits.ourservices.title">
        {t("ourservices:gudogBenefits")}
      </Text>
      <Accordion items={listBenefits} additionalInfo={additionalInfo} />
    </Box>
  );
};

interface Props {
  deviceType?: string;
}

function OurServices(props: Props) {
  const { deviceType } = props;
  const { t } = useTranslation("ourservices");
  const { country } = useContext(LocaleContext);

  const isMobileViewport = useIsMobile(deviceType);

  // Images
  const imgCover = "/images/landings/services_header_desktop.jpg";
  const imgBoarding = "/images/landings/advicefor_before_booking.jpg";
  const imgDayCare = "/images/landings/advicefor_after_booking.jpg";
  const imgWalking = "/images/landings/advicefor_meet_and_greet.jpg";
  const imgHouseSitting = isMobileViewport
    ? "/images/landings/ourservices_house_sitting_vertical.jpg"
    : "/images/landings/ourservices_house_sitting.jpg";

  return (
    <Layout withTransparentHeader title={t("ourservices:pageTitle")}>
      <HeroLanding
        isMobileViewport={isMobileViewport}
        imgsrc={imgCover}
        imgAlt={t("ourservices:pageTitle")}
        title={t("title")}
        height={["400px", "400px", "480px"]}
      />

      <Headline variant="ourservices" title={t("ourservices:heading")} />

      <TextWithImg
        title={t("ourservices:boardingTitle")}
        imgsrc={imgBoarding}
        imgAlt={t("ourservices:boardingTitle")}
        imgRight
      >
        <Text as="p" variant={"textWithImg.text"}>
          {t("ourservices:boardingDesc")}
        </Text>
      </TextWithImg>

      <TextWithImg
        title={t("ourservices:dayCareTitle")}
        imgsrc={imgDayCare}
        imgAlt={t("ourservices:dayCareTitle")}
        imgLeft
        bgColor="samoyedWhite"
        color="labradorBlack"
        showImgMobile={false}
      >
        <Text as="p" variant={"textWithImg.text"}>
          {t("ourservices:dayCareDesc")}
        </Text>
      </TextWithImg>

      <TextWithImg
        title={t("ourservices:walkingTitle")}
        imgsrc={imgWalking}
        imgAlt={t("ourservices:walkingTitle")}
        imgRight={!isMobileViewport}
      >
        <Text as="p" variant={"textWithImg.text"}>
          {t("ourservices:walkingDesc")}
        </Text>
      </TextWithImg>

      {["dk", "no", "se"].includes(country) && (
        <TextWithImg
          title={t("ourservices:houseSittingTitle")}
          imgsrc={imgHouseSitting}
          imgAlt={t("ourservices:houseSittingTitle")}
          imgLeft
          bgColor="samoyedWhite"
          color="labradorBlack"
        >
          <Text as="p" variant={"textWithImg.text"}>
            {t("ourservices:houseSittingDesc")}
          </Text>
        </TextWithImg>
      )}

      <Benefits />
    </Layout>
  );
}

 const _getServerSideProps = withDeviceType()();

export default OurServices;


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/ourservices',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  